import withTranslation from 'lib/shared/i18n/withTranslation';

import BaseField from '../BaseField/BaseField';

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isValidEmail = email => EMAIL_REGEX.test(email);

class EmailField extends BaseField {
  isValid(value) {
    if (value && !isValidEmail(value)) {
      return false;
    }

    return super.isValid(value);
  }

  getErrorMessage() {
    const { t, value, errorMessageKey } = this.props;

    // If we have a value, and are invalid, that means we got a incorrect email string
    if (value) {
      return t(errorMessageKey || `contact_form:contact_email_invalid`);
    }

    return super.getErrorMessage();
  }
}

export default withTranslation()(EmailField);
